import _ from 'lodash'
import { formatCell } from '@/utils/index'

export default {
  props: {
    showSummary: {
      type: Boolean,
      default: false,
    },
    columns: {
      type: Array,
      default: () => [],
    },
    tableData: {
      type: Array,
      default: () => [],
    },
    navButtons: {
      type: Array,
      default: () => [],
    },
    rightButtons: {
      type: Array,
      default: () => [],
    },
    multiSelect: {
      // 单选按钮是否可勾选
      type: Boolean,
      default: () => false,
    },
    cellStyle: {
      type: [String, Function],
      default: null,
    },
    defaultColumnConfig: {
      type: Object,
      default: () => {
        return {
          align: 'left',
          'header-align': 'left',
        }
      },
    },
    actionCenterColumn: {
      type: Object,
      default: () => {
        return {
          align: 'center',
          'header-align': 'center',
        }
      },
    },
    actionsColumn: {
      type: Object,
      default: () => {
        return {
          'min-width': 100,
        }
      },
    },
    treeProps: {
      type: Object,
      default: () => {
        return {}
      },
    },
    rowKey: {
      type: [String, Function],
      default: null,
    },
    formData: {
      type: Object,
      default: () => {
        return {}
      },
    },
    submitMode: {
      type: Boolean,
      default: false,
    },
    primaryKey: {
      type: String,
      default: null,
    },
    primaryKeySort: {
      type: String,
      default: 'desc',
    },
  },
  computed: {
    form() {
      let parent = this.$parent
      let parentName = parent.$options.componentName
      while (parentName !== 'ElForm') {
        parent = parent.$parent
        if (!parent) {
          return
        }
        parentName = parent.$options.componentName
      }
      return parent
    },
  },
  data() {
    return {
      dataSource: [],
    }
  },
  activated() {
    this.$nextTick(() => {
      this.handleHeight()
      this.$refs.table.doLayout()
    })
  },
  watch: {
    dataSource() {
      this.$nextTick(() => {
        this.$refs.table.doLayout()
        if (!this.showSummary) {
          return
        }
        let columns = this.flatColumns(this.columns)
        let start = _.findIndex(columns, 'sums')
        let end = _.findLastIndex(columns, 'sums')
        if (start > 0) {
          if (this.footer == null) {
            this.footer = this.$el.querySelectorAll(
              '.el-table__footer-wrapper tr >td'
            )
            this.footer[0].colSpan = start
            this.footer[0].style.textAlign = 'right'
            for (let j = 1; j < start; j++) {
              this.footer[j].style.display = 'none'
            }
            this.footer[end + 1].colSpan = columns.length - end - 1
            for (let j = end + 2; j < columns.length; j++) {
              this.footer[j].style.display = 'none'
            }
          }
        }
      })
    },
    'form.model': {
      handler(newVal) {
        let prop = this.$attrs.prop || this.$props.prop
        if (prop) {
          let data = _.get(newVal, prop)
          if (data == this.dataSource) {
            return
          }
          this.dataSource = data
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    doLayout() {
      let vm = this
      this.$nextTick(() => {
        vm.$refs.table.doLayout()
      })
    },
    handleHeight() {},
    flatColumns(columns) {
      return columns.flatMap((column) =>
        column.children ? [...this.flatColumns(column.children)] : [column]
      )
    },
    clearSelection() {
      let vm = this
      vm.$refs.table.clearSelection()
    },
    setCurrentRow(row) {
      let vm = this
      vm.$refs.table.setCurrentRow(row)
    },
    getSummaries(param) {
      const { data } = param
      let columns = this.flatColumns(this.columns)
      const sums = []
      columns.forEach((column, index) => {
        //index 为下标
        if (index === 0) {
          sums[index] = '合計'
          return
          //如果数据返回为字符串，这里会被认定为是0，所以判断
        } else if (index === 1) {
          sums[index] = ' '
          return
        }
        if (data) {
          const values = data.map((item) => Number(_.get(item, column.prop)))
          //item[column.property] 是html绑定的prop，如果没有prop则不显示合计结果
          if (!values.every((value) => isNaN(value))) {
            if (column.sums) {
              sums[index] = formatCell(
                values.reduce((prev, curr) => {
                  const value = Number(curr)
                  if (!isNaN(value)) {
                    return prev + curr
                  } else {
                    return prev
                  }
                }, 0),
                'number',
                null
              )
            }
          }
        }
      })
      return sums
    },
  },
}
